/** Display helpers do not migrate or rewrite values already stored in a record. */
export const keepCurrentOption = (options, current) => {
  const list = options.map((item) => typeof item === 'string' ? { value: item, label: item } : item);
  return current != null && current !== '' && !list.some((item) => String(item.value) === String(current))
    ? [...list, { value: current, label: String(current) }] : list;
};
export const schoolGradeOptions = (current) => keepCurrentOption([
  '', 'N\u00e3o se aplica', 'Ber\u00e7\u00e1rio I', 'Ber\u00e7\u00e1rio II', 'Maternal I', 'Maternal II',
  'Pr\u00e9 I', 'Pr\u00e9 II', ...Array.from({ length: 9 }, (_, i) => `${i + 1}\u00ba ano`),
  ...Array.from({ length: 8 }, (_, i) => `${i + 1}\u00aa s\u00e9rie`),
  ...Array.from({ length: 8 }, (_, i) => `EJA - etapa ${i + 1}`),
  ...Array.from({ length: 12 }, (_, i) => `${i + 1}\u00ba semestre`), 'Conclu\u00eddo', 'Outro',
], current);
export const schoolPeriodOptions = (current) => keepCurrentOption([
  '', 'Manh\u00e3', 'Tarde', 'Noite', 'Integral', 'Semi-integral', 'Intermedi\u00e1rio', 'Alternado', 'N\u00e3o se aplica', 'Outro',
], current);
export function formatBenefitCurrency(value) {
  if (value == null || value === '') return '';
  const text = String(value).trim();
  if (!text) return '';
  let numeric = text.replace(/R\$\s*/g, '').replace(/\s/g, '');
  if (!/^-?\d[\d.,]*$/.test(numeric)) return text;
  if (numeric.includes(',')) numeric = numeric.replace(/\./g, '').replace(',', '.');
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(numeric)) numeric = numeric.replace(/\./g, '');
  const amount = Number(numeric);
  return Number.isFinite(amount) ? amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : text;
}
export const localRecordDate = (date = new Date()) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export function safeHistoryPhoto(value) {
  const text = typeof value === 'string' ? value.trim() : '';
  if (/^data:image\/(?:png|jpe?g|gif|webp|bmp|avif);base64,[a-z0-9+/=\s]+$/i.test(text)) return text;
  if (/^(?:https?:\/\/|blob:https?:\/\/|\/[^/])[^\s<>]+$/i.test(text)) return text;
  return null;
}
export const displayedHousingType = (value) => value === 'Invas\u00e3o/Ocupa\u00e7\u00e3o' ? 'Ocupa\u00e7\u00e3o' : (value || '');
export function recordCourseHistory(education = {}, key = 'courseHistory') {
  const current = Array.isArray(education[key]) ? education[key] : [];
  if (key !== 'groupHistory' || education.__courseHistoryMerged || !Array.isArray(education.courseHistory)) return current;
  const signatures = new Set(current.map((item) => JSON.stringify(item)));
  return [...current, ...education.courseHistory.filter((item) => !signatures.has(JSON.stringify(item)))];
}
